<template>
  <el-upload
      :action="uploadUrl"
      :before-upload="handleBeforeUpload"
      :on-success="handlePictureSuccess"
      :on-error="handleUploadError"
      :on-remove="handleRemove"
      :on-exceed="handleExceed"
      :file-list="fileList"
      :multiple="fileLimit > 1"
      :data="paramsData"
      :limit="fileLimit"
      :list-type="listType"
  >
    <el-icon v-if="listType === 'picture-card'">
      <Plus/>
    </el-icon>
    <div class="click_upload" v-else>
      <el-button size="small" type="primary">点击上传</el-button>
    </div>
  </el-upload>
  <div v-if="isShowTip" class="el-upload__tip">
    只能上传{{ fileTypeName || "jpg、png、jpeg" }}文件，尺寸{{sizeInfo}}，且不超过 {{ fileSize }}MB
  </div>
</template>

<script>
import {
  reactive,
  toRefs,
  getCurrentInstance,
  computed,
  watch,
  onMounted,
} from "vue";
import {Delete, Download, Plus, ZoomIn} from "@element-plus/icons-vue";
import {ElMessage} from "element-plus";

export default {
  components: {
    Plus,
    Delete,
    Download,
    ZoomIn,
  },
  props: {
    value: [String, Object, Array],
    // 文件类型, 例如["doc", "xls", "ppt", "txt", "pdf"]
    fileType: {
      type: Array,
      default: () => ["png", "jpg", "jpeg"],
    },
    sizeInfo:{
      type:String,
      default: '1:1'
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 5,
    },
    // 最大允许上传个数
    fileLimit: {
      type: Number,
      default: 1,
    },
    // 文件列表类型 text/picture/picture-card
    listType: {
      type: String,
      default: "picture-card",
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true,
    },
  },

  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();
    const {fileType, fileSize, value} = props;
    let data = reactive({
      uploadUrl: proxy.$uploadImgUrlAlias,
      paramsData: {
        Authorization: "",
      },
      fileList: [],
      tempFileList: [], // 因为 fileList为只读属性，所以用了一个中间变量来进行数据改变的交互。
      fileTypeName: "",
    });

    onMounted(() => {
      if (value && value.length > 0) {
        if (!Array.isArray(value)) {
          data.fileList.push({
            name: value,
            url: value
          })
        } else {
          data.fileList = JSON.parse(JSON.stringify(value));
        }
      }
    });

    // 监听属性
    watch(props.value, (newValue, oldValue) => {
          data.tempFileList = newValue;
        },
        {immediate: true, deep: true}
    );

    // 计算属性
    let fileTypeName = computed(() => {
      let typeName = "";
      fileType.forEach((item) => {
        typeName += `${item},`;
      });
      return typeName;
    });

    data.fileTypeName = fileTypeName;

    // 上传前校检格式和大小
    let handleBeforeUpload = (file) => {
      if (fileType && file) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        const isTypeOk = fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
        if (!isTypeOk && file) {
          ElMessage.error(
              `文件格式不正确, 请上传${fileType.join("/")}格式文件!`
          );
          return false;
        }
      }

      // 校检文件大小
      if (fileSize && file) {
        const isLt = file.size / 1024 / 1024 < fileSize;
        if (!isLt) {
          ElMessage.error(`上传文件大小不能超过 ${fileSize} MB!`);
          return false;
        }
      }
      return true;
    };

    // 文件上传失败
    let handleUploadError = (err) => {
      ElMessage.error("上传失败, 请重试");
    };

    // 文件个数超出
    let handleExceed = () => {
      ElMessage.error(`超出上传文件个数,请删除以后再上传！`);
    };

    const handleRemove = (file, fileList) => {
      changeFileList(fileList);
    };

    const handlePictureSuccess = (res, file, fileList) => {
      ElMessage.success("上传成功");
      changeFileList(fileList);
    };

    // 文件列表改变的时候，更新组件的v-model的文的数据
    let changeFileList = (fileList) => {
      const tempFileList = fileList.map((item) => {
        let tempItem = {
          name: item.name,
          url: item.response ? item.response.msg : item.msg,
        };
        return tempItem;
      });
      emit("handleCurrentChange", tempFileList);
    };

    // 清空数组
    let clearAll = () => {
      data.fileList = [];
      changeFileList(data.fileList);
    };

    return {
      ...toRefs(data),
      handleBeforeUpload,
      handleUploadError,
      handleRemove,
      handlePictureSuccess,
      handleExceed,
      clearAll
    };
  },
};
</script>

<style lang="scss">
.el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  object-fit: contain;
}

.click_upload {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
